/**
 * 全局挂件
 */
import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useRouter } from 'next/router'
import { useTranslation } from '@/libs/next-lang'
import { IconSvg } from '@/components'
import { getLoginStatus, openUrl } from '@/utils'
import config from '@/utils/config'
import Widget from './Widget'
import useTutorial from './useTutorial'
import styles from './index.module.less'
import { Popover } from 'antd'

const TemplateEditorHelper = () => {
  const [visible, setVisible] = useState(false)
  const router = useRouter()
  const pathname = router.pathname
  const { show, render } = useTutorial({ isShow: visible, pathname })
  const isLogin: boolean = getLoginStatus()

  const { t } = useTranslation(['components'])
  const kefuPopoverTitleStyle = {
    fontWeight: 600,
    color: 'white',
    lineHeight: '16px',
    fontSize: '14px',
  }
  const kefuPopoverRemarkStyle = {
    fontWeight: 400,
    color: 'white',
    lineHeight: '16px',
    fontSize: '12px',
  }

  const handleOpen = () => {
    openUrl('https://q6y68vu0j8.feishu.cn/wiki/MzNMwDpCTiWA1QkT8lvcl67XnTe')
  }

  useEffect(() => {
    const withHelpPage = config?.withHelpPage || []
    if (withHelpPage.some(path => path === pathname)) {
      if (pathname === '/works') {
        // 作品库登录后才显示挂架
        if (isLogin) {
          setVisible(true)
        } else {
          setVisible(false)
        }
      } else {
        setVisible(true)
      }
    } else {
      setVisible(false)
    }
  }, [pathname, isLogin])

  if (!visible) {
    return null
  }

  const kefuQrcodePop = (
    <div style={{ padding: '8px 12px', textAlign: 'center' }}>
      <div style={kefuPopoverTitleStyle}>Creative Booster</div>
      <div style={kefuPopoverTitleStyle}>{t('components:t21')}</div>
      <div style={{ margin: '12px 0 12px 0' }}>
        <img
          width="120px"
          height="120px"
          src="https://cb-pro-static.oss-cn-shenzhen.aliyuncs.com/ad-web/chenzheqiwei.jpg"
        />
      </div>
      <div style={kefuPopoverRemarkStyle}>{t('components:t22')}</div>
      <div style={kefuPopoverRemarkStyle}>{t('components:t23')}</div>
    </div>
  )

  return (
    <div className={styles['cc-help']}>
      {pathname === '/works' && <Widget label={t('components:t104')} onShow={show} />}
      <div className="tutorial" onClick={handleOpen}>
        <IconSvg className="icon" type="icon-bangzhuzhongxin" />
        <div className="txt">{t('components:t102')}</div>
      </div>
      <Popover content={kefuQrcodePop} placement="left">
        <div className="contact-us">
          <IconSvg className="icon" type="icon-kefu" />
          <div className="txt">{t('components:t103')}</div>
        </div>
      </Popover>
      {render()}
    </div>
  )
}

export default observer(TemplateEditorHelper)
